import { Box, Button, ButtonProps, Icon } from "@chakra-ui/react";
import { IconType } from "react-icons";
import ActiveLink, { ActiveLinkProps } from "components/Shared/ActiveLink";

type Props = Omit<ActiveLinkProps & ButtonProps, "children"> & {
  children: string;
  IconComponent?: IconType;
};

export default function NavLink({ children, IconComponent, ...rest }: Props) {
  const textContent = typeof children === "string" ? children : "";
  return (
    <Button
      as={ActiveLink}
      leftIcon={IconComponent && <Icon as={IconComponent} />}
      variant="ghost"
      display="flex"
      justifyContent="flex-start"
      alignItems="baseline"
      minW="11em"
      fontSize="sm"
      fontFamily="body"
      fontWeight={300}
      px={3}
      py={2}
      lineHeight="normal"
      height="auto"
      color="magenta.dark"
      textTransform="none"
      borderRightWidth={3}
      borderLeftRadius="md"
      borderRightRadius={0}
      position="relative"
      _activeLink={{ borderRightColor: "lightPink", fontWeight: 500 }}
      sx={{ ".chakra-button__icon": { verticalAlign: "middle" } }}
      {...rest}
    >
      <Box
        as="span"
        data-label={textContent}
        _after={{
          content: "attr(data-label)",
          display: "block",
          height: 0,
          visibility: "hidden",
          overflow: "hidden",
          userSelect: "none",
          pointerEvents: "none",
          fontWeight: 500,
        }}
      >
        {children}
      </Box>
    </Button>
  );
}
